import type { JSX } from 'react';
import React, { useState } from 'react';
import { useParams } from 'react-router';

import type { Creative } from '@feathr/blackbox';
import { DISPLAY_CREATIVE_CLASSES } from '@feathr/blackbox';
import { Table, Toolbar } from '@feathr/components';
import Page from '@feathr/extender/App/Page';
import { useStore } from '@feathr/extender/state';

import AddCreativeButton from './AddCreativeButton';
import CreativesCampaignSelect from './CreativesCampaignSelect';
import CreativesClassSelect from './CreativesClassSelect';
import CreativesNameSearch from './CreativesNameSearch';
import EventCreativesColumns from './EventCreativesColumns';

export interface ICreativesFilters {
  name__icontains?: string;
  _parent?: string;
  spec?: string;
}

function EventCreativesPage(): JSX.Element {
  const { eventId } = useParams<{ eventId: string }>();

  const [filters, setFilters] = useState<ICreativesFilters>({});

  const { Creatives } = useStore();

  const filterElements = [
    <>
      <CreativesClassSelect filters={filters} setFilters={setFilters} />
      <CreativesCampaignSelect eventId={eventId} filters={filters} setFilters={setFilters} />
    </>,
    <>
      <CreativesNameSearch filters={filters} setFilters={setFilters} />
    </>,
  ];

  const actions = (
    <Toolbar>
      <AddCreativeButton />
    </Toolbar>
  );

  return (
    <Page actions={actions} title={'Creatives'}>
      <Table<Creative>
        collection={Creatives}
        columns={EventCreativesColumns()}
        filterElements={filterElements}
        filters={{
          ...filters,
          _cls__in: DISPLAY_CREATIVE_CLASSES,
          event: eventId,
        }}
        initialSort={[{ id: 'name' }]}
      />
    </Page>
  );
}

export default EventCreativesPage;
